

import { getEventTypes } from "../api/user/home/home"
import { getPublicEventTypes } from "../api/checkout/Event"

let EVENT_TYPES_OBJECT : any[] = []
let EVENT_TYPES : string[] = []
let EVENT_TYPE_LABELS : string[] = []

let EVENT_TYPES_OBJECT_FILTERED : any[] = []
let EVENT_TYPES_FILTERED : string[] = []
let EVENT_TYPE_LABELS_FILTERED : string[] = []


const fetchEventTypes = async (token : string | null) => {

    let response : any = null

    if (token !== null) {
        response = await getPublicEventTypes({access_token: token})
    } else [
        response = await getEventTypes()
    ]

    console.log("rs," , response)
    EVENT_TYPES_OBJECT = response.data.map((event:any, index : number) => {
        return {
            type: event.type,
            display_name: event?.display_name ?? index
        }
    })

    console.log('EVENT_TYPES_OBJECT:', EVENT_TYPES_OBJECT);

    EVENT_TYPES = EVENT_TYPES_OBJECT.map((event) => event.type)
    EVENT_TYPE_LABELS = EVENT_TYPES_OBJECT.map((event) => event.display_name)

    EVENT_TYPES_OBJECT_FILTERED = EVENT_TYPES_OBJECT.filter((event) => event.type !== 'private_class')

    EVENT_TYPES_FILTERED = EVENT_TYPES_OBJECT_FILTERED.map((event) => event.type)
    EVENT_TYPE_LABELS_FILTERED = EVENT_TYPES_OBJECT_FILTERED.map((event) => event.display_name)




    return response
}

const initializeEventTypes = async () => {

    try {

        await fetchEventTypes(null);

    } catch (error) {
        console.log("EVENT_TYPES_OBJECT(failure):", EVENT_TYPES_OBJECT)
        console.error('Failed to fetch and assign event types:', error);
    }
}

const initializeEventTypesPublic = async (token : string) => {

    try {

        await fetchEventTypes(token);

    } catch (error) {
        console.log("EVENT_TYPES_OBJECT(failure):", EVENT_TYPES_OBJECT)
        console.error('Failed to fetch and assign event types:', error);
    }
}



const getEventLabel = (type:string) => {
    const index = EVENT_TYPES.indexOf(type)

    return EVENT_TYPE_LABELS[index]
}

const getEventType = (label:string) => {
    const index = EVENT_TYPE_LABELS.indexOf(label)
    return EVENT_TYPES[index]
}

export {
    EVENT_TYPES,
    EVENT_TYPE_LABELS,
    EVENT_TYPES_OBJECT_FILTERED,
    EVENT_TYPES_FILTERED,
    EVENT_TYPE_LABELS_FILTERED,
    getEventLabel,
    getEventType,
    EVENT_TYPES_OBJECT,
    initializeEventTypes,
    initializeEventTypesPublic,
}